import type { ActivityCockpitSnapshot } from '@internal/spassu-code-contract';
import {
  adaptCockpitSnapshot,
  type CockpitRailSemanticInput,
  type CockpitRailState,
  type CockpitViaSemantics,
  type CockpitViewModel,
} from '@internal/spassu-code-cockpit-ui';

const FRONTIER_SEMANTICS: CockpitViaSemantics = {
  viaLabel: 'Frontier',
  presentRail: input => ({
    label: input.skillLabel ?? input.category,
    state: frontierRailState(input),
  }),
};

export function adaptFrontierCockpit(
  snapshot: ActivityCockpitSnapshot,
): CockpitViewModel {
  if (
    snapshot.workPath !== 'frontier-web' &&
    snapshot.workPath !== 'cli-standalone'
  ) {
    throw new Error(
      'Frontier cockpit adapter received an incompatible work path.',
    );
  }
  return adaptCockpitSnapshot(snapshot, FRONTIER_SEMANTICS);
}

function frontierRailState({
  category,
  confidence,
}: CockpitRailSemanticInput): CockpitRailState {
  if (category === 'unclassified') return 'void';
  if (category === 'waiting') return 'wait';
  if (category === 'blocked') return 'covered';
  if (confidence === 'inferred') return 'inferred';
  if (confidence === 'detected') return 'detected';
  return 'evidence';
}
